export class GetPastHospHX
{
    pasT_HOSP_STRUCTURE_ID: string = "";
    patienT_ACCOUNT: string = "";
    hosP_DATE: string = "";
    reason: string = "";
    duration: string = "";
    comments: string = "";
    encounteR_ID: string = "";
    practicE_CODE: string = "";
    createD_BY: string = "";
    createD_DATE: string = "";
    modifieD_BY: string = "";
    modifieD_DATE: string = "";
}


export class SavePastHX{
    pastHospitalizationId : string = "";
    patientAccount : string = "";
    language : string = "";
    practiceCode : string = "";
    hospDate : string = "";
    reason : string = "";
    duration : string = "";
    comment : string = "";
    createdBy : string = "";  
}

export class DeletePastHospHX
{
    pastSurgicalHistoryStructureId: string;
    patientAccount: string;
    practiceCode: string;
    modifiedBy: string;
    deleted: boolean;
}


